var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddressBook(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 16.8748C4.16667 17.2198 4.44667 17.4998 4.79167 17.4998H13.6683C14.6375 17.4998 15 17.1956 15 16.1664V14.9623M4.16667 16.8748C4.16667 16.3775 4.36421 15.9006 4.71584 15.5489C5.06747 15.1973 5.54439 14.9998 6.04167 14.9998H14.5017C14.69 14.9998 14.8561 14.9873 15 14.9623M4.16667 16.8748V5.16642C4.16667 4.21976 4.10667 3.17559 5.07667 2.68142C5.43333 2.49976 5.9 2.49976 6.83333 2.49976H14.5C15.53 2.49976 15.8333 2.86392 15.8333 3.83309V13.6664C15.8333 14.4956 15.5983 14.8539 15 14.9623",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95833 10.4164C8.73732 10.4164 8.52536 10.3286 8.36908 10.1723C8.2128 10.0161 8.125 9.8041 8.125 9.58309V7.61642L10 6.24976L11.875 7.61642V9.58309C11.875 9.8041 11.7872 10.0161 11.6309 10.1723C11.4746 10.3286 11.2627 10.4164 11.0417 10.4164H8.95833Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressBook);
export default __webpack_public_path__ + "static/media/address_book.adc30c1fd7fdb3fcc186e9b587290b21.svg";
export { ForwardRef as ReactComponent };